// find the highest percentage decrease between monthly and yearly prices of specified products
import {Product} from '../product';
import {findBestPrice, UpsellBillingCycle} from './find-best-price';
import {Fragment, memo} from 'react';
import {Trans} from '@ui/i18n/trans';

interface UpsellLabelProps {
  products?: Product[];
  selectedCycle?: UpsellBillingCycle;
}
export const UpsellLabel = memo(({products, selectedCycle}: UpsellLabelProps) => {
  const upsellPercentage = calcHighestUpsellPercentage(products);

  if (upsellPercentage <= 0) {
    return null;
  }

  // On mobile: only show when yearly is selected. On desktop (md+): always show.
  const mobileVisibilityClass = selectedCycle === 'yearly' ? 'block' : 'hidden';

  return (
    <Fragment>
      <span
        className={`font-medium text-positive-darker ${mobileVisibilityClass} mt-6 md:mt-0 md:inline md:ml-6`}
      >
        (
        <Trans
          message="Save up to :percentage%"
          values={{percentage: upsellPercentage}}
        />
        )
      </span>
    </Fragment>
  );
});

function calcHighestUpsellPercentage(products?: Product[]) {
  if (!products?.length) return 0;

  const decreases = products.map(product => {
    if (product.hidden) return 0;

    const monthly = findBestPrice('monthly', product.prices);
    const yearly = findBestPrice('yearly', product.prices);

    if (!monthly || !yearly) return 0;

    // monthly plan per year amount
    const monthlyAmount = monthly.amount * 12;
    const yearlyAmount = yearly.amount;

    const savingsPercentage = Math.round(
      ((monthlyAmount - yearlyAmount) / monthlyAmount) * 100,
    );

    if (savingsPercentage > 0 && savingsPercentage <= 200) {
      return savingsPercentage;
    }

    return 0;
  });

  return Math.max(Math.max(...decreases), 0);
}
